import gql from 'graphql-tag';

export const deleteEventMutation = gql`
  mutation ($eventId: Int) {
    deleteEventById(eventId: $eventId)
    {
      rows_deleted
    }
  }
`
